// DEV-2358 — Refunds Agent shared constants (Appendix B tokens / links).

export const REFUNDS_AGENT_KB_URL =
	'https://docs.clickguard.com/en/articles/24264-refunds-agent'

/**
 * Figma "Data Sheet" drawers float as a card inset 12px from the top/right/bottom
 * with a 12px radius (the dimmed page shows through the gap). Applied as an inline
 * `style` to override the DS Sheet's flush `inset-y-0 right-0` — DS twMerge isn't
 * prefix-aware, so a className override wouldn't reliably win. `width` must be set
 * here too: the Sheet spreads this style over its own `{ width }`, replacing it.
 * Shared by the Submission and Configuration drawers so they stay in sync.
 */
export const REFUNDS_SHEET_FLOAT_STYLE = {
	top: 12,
	right: 12,
	bottom: 12,
	width: 476,
	borderRadius: 12
}

/** Google review turnaround copy, reused across setup + tooltips. */
export const GOOGLE_REVIEW_NOTE =
	"Please note that Google's review process can take up to 3 months."

/** Terminal statuses shown in the redesign table / counted in summaries (§5). */
export const TERMINAL_STATUSES = ['submitted', 'no_evidence', 'failed'] as const

/**
 * Two CTA colour systems — do NOT unify (B0). Lime accent for setup/connect CTAs.
 * Radius 8px + SemiBold + lime glow shadow match the Figma DS button.
 */
export const LIME_CTA_CLASS =
	'rounded-[8px] font-semibold bg-b-yellow border border-b-yellow-dark text-on-lemon hover:brightness-95 shadow-s-yellow'

/** Brand-blue CTA — "Claim refund now" / "Try AI" only. */
export const BRAND_CTA_CLASS = 'rounded-[8px] font-semibold bg-brand text-white hover:brightness-110'
